// extracted by mini-css-extract-plugin
export default {"productCarousel":"Pj","twoColumns":"Qj","subhed":"Rj","promo":"Sj","questionIcon":"Tj","thumbContainer":"Uj","carousel":"Vj","tape":"Wj","flexContainer":"Xj","nav":"Yj","body":"Zj","reviews":"ak","header":"bk","hed":"ck","priceContainer":"ek","oldPrice":"fk","newPrice":"gk","infoTabs":"hk","tabs":"ik","text":"jk","questionWrapper":"kk","isQuantity":"lk","title":"mk","titleRight":"nk","addToCart":"ok","servingsPerItem":"pk","quantityInput":"qk","quantityButton":"rk","takeTheQuiz":"sk"};
    if(module.hot) {
      // 1711394573813
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  